﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { config } from '../../assets/config';
import {Category} from '../_models/category';
import {SubCategory} from '../_models';

@Injectable()
export class CategoryService {
    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<Category[]>(`${config.apiUrl}/categories`);
    }

    getById(id: number) {
        return this.http.get(`${config.apiUrl}/categories/` + id);
    }

    getByIntercalaireId(intercalaireId: string) {
        return this.http.get(`${config.apiUrl}/intercalaires/` + intercalaireId +
            '/categories?filter={"include":["words"]}');
    }

    getByCategoryId(categoryId: string) {
        return this.http.get(`${config.apiUrl}/categories/` + categoryId +
            '/subcategories?filter={"include":["words"]}');
    }

    register(category: Category) {
        return this.http.post(`${config.apiUrl}/categories`, category);
    }

    registerByIntercalaireId(intercalaireId: string, category: Category) {
        return this.http.post(`${config.apiUrl}/intercalaires/` + intercalaireId + '/categories', category, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    registerByParentId(categoryId: string, subCategory: Category) {
        return this.http.post(`${config.apiUrl}/categories/` + categoryId + '/subCategories', subCategory, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    update(category: Category) {
        return this.http.put(`${config.apiUrl}/categories/` + category.id, category, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    updateSubCategory(subCategory: SubCategory) {
        return this.http.put(`${config.apiUrl}/subCategories/` + subCategory.id, subCategory, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    delete(id: number) {
        return this.http.delete(`${config.apiUrl}/categories/` + id);
    }
}
